// extracted by mini-css-extract-plugin
export default {"Pricing__Item":"Pricing_Pricing__Item__AYYP+","Name":"Pricing_Name__tqSw5","Amount":"Pricing_Amount__rVkjY"};